"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseEntityQuery_1 = require("./BaseEntityQuery");

var BaseCollectionQuery =
/** @class */
function (_super) {
  __extends(BaseCollectionQuery, _super);

  function BaseCollectionQuery(queryOptions, translationHelper) {
    return _super.call(this, queryOptions, translationHelper) || this;
  }

  BaseCollectionQuery.prototype.getItem = function (executionOptions, collection) {
    var culture = executionOptions.culture;
    var _a = this.options,
        sort = _a.sort,
        _b = _a.startIndex,
        startIndex = _b === void 0 ? 0 : _b,
        endIndex = _a.endIndex,
        index = _a.index;
    var sortedCollection = this.applySort(collection, sort, culture);
    sortedCollection = sortedCollection.slice(startIndex, endIndex);

    if (sortedCollection && sortedCollection.length > 0) {
      if (typeof index === 'number') {
        var targetIndex = this.getIndex(index, sortedCollection);

        if (targetIndex > -1) {
          var item = sortedCollection[targetIndex];
          return item;
        }
      } else {
        return sortedCollection;
      }
    }

    return;
  };

  BaseCollectionQuery.prototype.getIndex = function (targetIndex, collection) {
    var response = -1;

    if (collection && collection.length > 0 && Math.abs(targetIndex) < collection.length) {
      if (targetIndex >= 0) {
        response = targetIndex;
      } else {
        // If the target index is negative take from the back of the array
        response = collection.length + targetIndex;
      }
    }

    return response;
  };

  return BaseCollectionQuery;
}(BaseEntityQuery_1.BaseEntityQuery);

exports.BaseCollectionQuery = BaseCollectionQuery;